<template>
  <div class="container">
    <div class="linkman">
      <p class="title">
        相关联系人信息
        <span>(共<span style="color:red;">{{detail&&detail.linkcount||0}}</span>条)</span>
      </p>
      <ul class="list" v-show="!loading">
        <li  v-for="(v,i) in dataSource" :key="i">
          <div>
            <div v-if="v.name"><p> <span>姓名</span><span> {{v.name}}</span></p></div>
            <div v-if="v.email"><p> <span>邮件</span><span> {{v.email}}</span></p></div>
            <div v-if="v.tel"><p> <span>电话</span><span>  {{v.tel}}</span></p></div>
            <div v-if="v.msn"><p> <span>MSN</span><span> {{v.msn}}</span></p></div>
            <div v-if="v.skype"><p> <span>Skype</span> <span> {{v.skype}}</span></p></div>
            <div v-if="v.facebook||v.twitter||v.linkedin"><p><span>社交</span><span><a title="facebook" class="facebook bg" target="_blank" v-if="v.facebook" :href="v.facebook"></a><a title="twitter" class="twitter bg" target="_blank" v-if="v.twitter" :href="v.twitter"></a><a title="linkedin" class="linkedin bg" target="_blank" v-if="v.linkedin" :href="v.linkedin"></a></span></p></div>
          </div>
        </li>
      </ul>
      <a-pagination v-show="!loading&&!emptyData" v-model="pageNo" :total="totalCount" @change="changepage" :defaultPageSize="pageSize" />
    <div v-show="loading" style="text-align:center;margin:150px;">
          <a-spin tip="加载中...">
            <a-icon
              slot="indicator"
              type="loading"
              style="font-size: 48px;width:48px;height:48px;"
              spin
            />
          </a-spin>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading:false,
      pageNo: 1,
      totalCount: 0,
      pageSize: 10,
      dataSource: [],
      keyPerson: {},
      emptyData:false
    };
  },
  props: {
    detail: { type: Object, required: true }
  },
  watch: {
    detail() {
      this.loadLinkManList();
    }
  },
  created() {
    this.loadLinkManList();
  },
  methods: {
    changepage(v) {
      this.pageNo = v;
      this.loadLinkManList();
    },
    loadLinkManList() {
      this.loading=true;
      this.$http
        .post("/zzLinkList", {
          pid: this.detail.id,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        })
        .then(res => {
          if (!res.error) {
            this.totalCount = parseInt(res.totalCount);
            this.pageNo = parseInt(res.pageNo);
            this.pageSize = parseInt(res.pageSize);
            this.dataSource = res.data.list;
            this.emptyData = this.dataSource.length == 0;
          }
          this.loading=false;
        }).catch(e => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  min-height: 500px;
  display: flex;
  flex-flow: row;
  .linkman {
    flex: 1;
    width: 850px;
    .ant-pagination {
      margin: 10px;
    }
    .list {
      list-style: none;
      padding: 0;
      //margin-right: 70px;
      li {
        border: 1px solid #eee;
        margin: 10px;
        position: relative;
        & > div {
          color: #666;
          height: 100%;
          padding: 16px 20px 0;
          word-break: break-all;
          & > div {
            padding-bottom: 16px;
            width: 284px;
            display:inline-block;
            line-height: 18px;
            &>p{
              display:flex;
              justify:center;
              align-items:center;
              margin-block-start: 0em;
              margin-block-end: 0em;
              &>span{
                height:100%;
                display:inline-block;
                width: 230px;
                margin: 0 auto;
              }
              & > span:first-child {
                text-align: right;
                width: 44px;
                font-weight: bold;
                margin-right: 5px;
              }
              &>.bg{
                width: 230px;
                .a{
                  display:inline-block;
                  width:20px ;
                  height: 20px;
                  text-align: left;
                }
              }
            }
          }
        }
      }
    }
  }
  .title {
    color: #52718e;
    font-size: 17px;
    margin: 20px 0 0 10px;
  }
  .facebook::after{
    position: relative;
    top: 2px;
    width:30px ;
    height: 20px;    
    content: "";
    display: inline-block;
    background-repeat: no-repeat;
    background-position:left;
    background-size:contain;
    background-image: url("~@/assets/img/facebook.png");
  }
    .twitter::after{
    position: relative;
    top: 2px;
    width:30px ;
    height: 20px;    
    content: "";
    display: inline-block;
    background-repeat: no-repeat;
    background-position:left;
    background-size:contain;    
    background-image: url("~@/assets/img/twitter.png");
  }
    .linkedin::after{
    position: relative;
    top: 2px;
    width:30px ;
    height: 20px;  
    content: "";
    display: inline-block;
    background-repeat: no-repeat;
    background-position:left;
    background-size:contain;    
    background-image: url("~@/assets/img/linkedin.png");
  }
}
</style>
